const Headline = ({ title, subtitle }) => {
  return (
    <div className="text-center mx-auto py-16">
      <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 gradient-text">
        {title}
      </h2>
      <div className="section-divider mb-6" />
      {subtitle && (
        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto text-balance">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default Headline;
